// extracted by mini-css-extract-plugin
export var tabBar = "styles-module__tabBar___ABu_G";
export var explore = "styles-module__explore___dppZY";
export var tab = "styles-module__tab___D9FEg";
export var active = "styles-module__active___vQN6t";